/**
 * VistoeraTASK-00668 / 00669 — upgrade-modal "当前套餐" label.
 *
 * Never invent 免费版 when plan_key is null.
 * Never treat catalog LOADING as 套餐异常 (TASK-00669 flash fix).
 */

export type PlanCatalogLoadState = 'loading' | 'ready' | 'error'

export function planUpgradeCurrentLabel(
  currentPlanKey: string | null | undefined,
  catalogDisplayName: string | null | undefined,
  options?: {
    /** Known display name from tenant list/detail (canonical, already loaded). */
    knownDisplayName?: string | null
    catalogState?: PlanCatalogLoadState
  },
): string {
  if (!currentPlanKey) return '未配置'

  // Fresh catalog row wins once ready (supports rename without flash of 异常).
  if (catalogDisplayName) return catalogDisplayName

  // Parent list/detail already has a trusted name — show immediately while loading.
  const known = options?.knownDisplayName?.trim()
  if (known) return known

  const state = options?.catalogState ?? 'ready'
  if (state === 'loading') return '正在获取当前套餐…'
  if (state === 'error') return '获取失败，请重试'

  // Catalog loaded and key has no row → real orphan / broken association.
  return '套餐异常'
}
